if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.includesAny
) {
  Object.defineProperty(Array.prototype, 'includesAny', {
    value(...args) {
      for (const a of args.flat()) {
        if (this.includes(a)) return true;
      }
      return false;
    }
  });
}